import { openAppDirective } from './directives';
import { mixinWeixinShare } from './mixins';
import { isInHeybox } from '_lib/utils';
import { getAppType } from './util'

export default {
  install(Vue, openAppConfig) {
    if (isInHeybox()) {
      return
    }
    if (getAppType() === 'weixin') {
      mixinWeixinShare(Vue, openAppConfig);
    }
    Vue.directive('open-app', openAppDirective);
  }
};